Object.defineProperty(window, "Cookies", {
  get: function () {
    return document.cookie.split(';').reduce(function (cookies, cookie) {
      cookies[cookie.split("=")[0].replace(' ', '')] = unescape(cookie.split("=")[1]);
      return cookies;
    }, {});
  }
});

//GTM Google tag manager tracking

function publishToGoogle(gtmData) {
  window.dataLayer = window.dataLayer || [];
  console.log(gtmData);
  window.dataLayer.push(gtmData);
}
jQuery(document).ready(function () {
  publishToGoogle(GTM_Data_pageView);
});

function gtmTrackingLogin(eventName, loginStatus, loginType, loginAuthenticationCode, userType, loginFailure, pageSection){
  var GTM_Data_login = { "event": eventName };
  GTM_Data_login.loginStatus = loginStatus;
  GTM_Data_login.loginType= loginType;
  GTM_Data_login.loginAuthenticationCode = loginAuthenticationCode;
  GTM_Data_login.userType = userType;
  GTM_Data_login.pageSection = pageSection;
  if (loginFailure !== "") {
    GTM_Data_login.loginFailure = loginFailure;
    GTM_Data_login.userType = "public";
  }
  
  publishToGoogle(GTM_Data_login);
}
function getEnvironment() {
  var hostname = window.location.hostname;
  var regex = /(local|stage|schwarzundbold)/;
  if (regex.exec(hostname)) {
      return "staging";
  }
  return "production";
}
//page View Event for parkinson portal
function pageViewEvent() {
  var GTM_Data_pageView = {};
  GTM_Data_pageView.event = "parkinsonPortalLandingPageView";
  GTM_Data_pageView.site = "AbbVie Care";
  GTM_Data_pageView.environment = getEnvironment();
  GTM_Data_pageView.pageName = "AbbVie Care Online-Serviceportal";
  GTM_Data_pageView.pageSection = "Parkinson Portal";
  GTM_Data_pageView.pageLanguage = "de";
  GTM_Data_pageView.pageCountry = "DE";
  GTM_Data_pageView.pageType = "overview";
  GTM_Data_pageView.userType = "public";
  GTM_Data_pageView.associatedDisease = ["Parkinson"];
  GTM_Data_pageView.associatedDrug = ["DUODOPA"];
  GTM_Data_pageView.keyMessage = [];
  publishToGoogle(GTM_Data_pageView);
}

//forms tracking
function gtmTrackingForms(eventName, formName, formStepCount, formStep, formStepNr){
  var GTM_Data_forms = { "event": eventName };
  GTM_Data_forms.formName = formName;
  GTM_Data_forms.formStepCount = formStepCount;
  if (formStep !== "") {
    GTM_Data_forms.formStep = formStep;
  }
  if (formStepNr !== "") {
    GTM_Data_forms.formStepNr = formStepNr;
  }
  publishToGoogle(GTM_Data_forms);
}


jQuery('.btn-tracked').on('click', function (event) {

    var name;
  var label;
  var GTM_Data_buttons = {"event":"buttonClick"};

    name = jQuery(this).attr('data-tracking-name');
    label = jQuery(this).attr('data-tracking-label');

    if (typeof label !== 'undefined') {
        GTM_Data_buttons.buttonLabel = label;
    }
    else {
        GTM_Data_buttons.buttonLabel = "n/a";
    }

    if (typeof name !== 'undefined') {
        GTM_Data_buttons.buttonName = name;
        publishToGoogle(JSON.parse(JSON.stringify(GTM_Data_buttons)));
    }


});



// FN

jQuery('.btn-tracked').on('click', function (event) {

    var name;
  var label;
  var GTM_Data_buttons = {"event":"buttonClick"};

    name = jQuery(this).attr('data-tracking-name');
    label = jQuery(this).attr('data-tracking-label');

    if (typeof label !== 'undefined') {
        GTM_Data_buttons.buttonLabel = label;
    }
    else {
        GTM_Data_buttons.buttonLabel = "n/a";
    }

    if (typeof name !== 'undefined') {
        GTM_Data_buttons.buttonName = name;
        publishToGoogle(JSON.parse(JSON.stringify(GTM_Data_buttons)));
    }


});


// FN


function generateSelectionItems($select, $type, $default, $arg1, $arg2) {

  var $i,$html;

  switch ($type) {
    case 'yearsFromNow':

      $html = '';
      $i = new Date().getFullYear();
      $i = $i - ($arg2 - 1);
      while ($i > parseInt($arg1)) {
        $i--;
        $html += ('<option value="' + $i + '">' + $i + '</option>');
      }

      break;
    case 'getMonths':

      $html = '<option value="01">Januar</option><option value="02">Februar</option><option value="03">März</option><option value="04">April</option><option value="05">Mai</option><option value="06">Juni</option><option value="07">Juli</option><option value="08">August</option><option value="09">September</option><option value="10">Oktober</option><option value="11">November</option><option value="12">Dezember</option>';

      break;
    case 'countFromTo':

      $i = parseInt($arg1) -1 ;
      $html = '';
      while ($i < parseInt($arg2)) {

        $i++;
        $html += ('<option value="' + ($i < 10 ? '0' : '') + $i + '">' + ($i < 10 ? '0' : '') + $i + '</option>');
      }

      break;

    case 'time':
      $html = '<option value="08:00">08:00</option><option value="08:30">08:30</option><option value="09:00">09:00</option><option value="09:30">09:30</option><option value="10:00">10:00</option><option value="10:30">10:30</option><option value="11:00">11:00</option><option value="11:30">11:30</option><option value="12:00">12:00</option><option value="12:30">12:30</option><option value="13:00">13:00</option><option value="13:30">13:30</option><option value="14:00">14:00</option><option value="14:30">14:30</option><option value="15:00">15:00</option><option value="15:30">15:30</option><option value="16:00">16:00</option><option value="16:30">16:30</option><option value="17:00">17:00</option><option value="17:30">17:30</option><option value="18:00">18:00</option><option value="18:30">18:30</option><option value="19:00">19:00</option><option value="19:30">19:30</option>';
      break;

    case 'time_end_selected':
      $html = '<option value="08:30">08:30</option><option value="09:00">09:00</option><option value="09:30">09:30</option><option value="10:00">10:00</option><option value="10:30">10:30</option><option value="11:00">11:00</option><option value="11:30">11:30</option><option value="12:00">12:00</option><option value="12:30">12:30</option><option value="13:00">13:00</option><option value="13:30">13:30</option><option value="14:00">14:00</option><option value="14:30">14:30</option><option value="15:00">15:00</option><option value="15:30">15:30</option><option value="16:00">16:00</option><option value="16:30">16:30</option><option value="17:00">17:00</option><option value="17:30">17:30</option><option value="18:00">18:00</option><option value="18:30">18:30</option><option value="19:00">19:00</option><option value="19:30">19:30</option><option selected value="20:00">20:00</option>';
      break;

    default:
      console.log('No valid generateSelectionItems type set (?)');

  }

  //$html = $default + $html;

  $select.append($default);
  $select.append($html);

}

var isXstage = window.location.hostname === 'abbvie-care-stage.twt-dh.de';
var activationKey;
var authToken = null;
var redirect = false;
var sec_id = false;
var user_id = false;
var registration;


function gup( name, url ) {
  if (!url) {
    url = location.href;
  }
  name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
  var regexS = "[\\?&]"+name+"=([^&#]*)";
  var regex = new RegExp( regexS );
  var results = regex.exec( url );
  return results == null ? null : results[1];
}

function jsUcfirst(string)
{
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function deactivate_system_screen() {
  $('body').removeClass('system');
}

function activate_system_screen(activeTab) {
  $('body').addClass('system');
  $('.nav-tabs a[href="' + activeTab + '"]').tab('show');
}

function isInArray(value, array) {
  return array.indexOf(value) > -1;
}

function registrationFurtherQuestions(timeofcreation, brand, indication, answer1, answer2) {

  var params = { 'timeofcreation': timeofcreation, 'brand': brand, 'indication': indication, 'answer1': answer1, 'answer2': answer2 };

  jQuery.ajax({
      url: "/wp-json/ac/internal/registrationFurtherQuestions/?params=" + encodeURIComponent(JSON.stringify(params)),
      type: "get",
      success: function (data) {
          if (!data) {
              //console.log('error setAttr!');
          }
      }
  });

}



function callback($data, $method, $form, $request) {
  $('body').removeClass('preloader');
  //console.log('response from the api',$data);

  if ($method === 'loginRequest' && $data.success) {
    user_id = $data.data.user_id;
    sec_id = $data.data.sec_id;
    //console.log('is login -> saving vars',user_id,sec_id);
  } else {
    //console.log('aint no loginReqeust');
  }

  switch ($form) {

    case 'patient__form--serviceportal':

      if (!$data.success) {
        $('[data-form="' + $form + '"]').find('small.form-text').text($data.exception).slideDown();
      }

      if ($data.success) {

        if ($data.data.isHcpPortalUser === true) {

          $('[data-form="' + $form + '"]').find('small.form-text').text('Dies ist kein gültiger Patienten-Login.').slideDown();

        } else {

          redirect = (!isXstage ? '/portal/' : 'https://abbvie-care-stage.twt-dh.de/portal/');

          if ($data.data.password_expired === true) {
            activate_system_screen('pwd-expired');
            return false;
          }

          window.location.href = redirect;


        }

      }


      break;
    case 'patient__form--aktivierung':

      if (!$data.success) {
        $('[data-form="' + $form + '"]').find('small.form-text').text($data.exception).slideDown();
      }


      if ($data.success) {
        window.location.href = (!isXstage ? '/portal/activation?key=' + encodeURI($request.activation_id) : 'https://abbvie-care-stage.twt-dh.de/portal/activation?key=' + encodeURI($request.activation_id));
      }

      break;
    case 'patient__form--serviceportal-pumpennummer':

      if (!$data.success) {
        $('[data-form="' + $form + '"]').find('small.form-text').text($data.exception).slideDown();
        gtmTrackingLogin("loginFailure", "logged out", "pump number", $request.pump_id, "patient", "invalid pump number", "Parkinson Portal");
        //console.log($data.exception);
      }

      if ($data.success) {
        gtmTrackingLogin("loginSuccess", "logged in", "pump number", $request.pump_id, "patient", "", "Parkinson Portal");
        pageViewEvent();
        window.location.href = (!isXstage ? '/portal/?legacy' : 'https://abbvie-care-stage.twt-dh.de/portal/?legacy');
      }
      break;
    case 'patient__form--therapiescout':

      if (!$data.success) {
        $('[data-form="' + $form + '"]').find('small.form-text').text($data.exception).slideDown();
        gtmTrackingLogin("loginFailure", "logged out", "batch number", $request.authCode, "patient", "invalid batch number", "Therapiescout");

        //console.log($data.exception);
      }

      if ($data.success && $data.data.medicationName.toLowerCase().match(/venetoclax|venclyxto|venclexta/)) {
        window.location.href = '/venclyxto/';
      }
      if($data.success){
        gtmTrackingLogin("loginSuccess", "logged in", "batch number", $request.authCode, "patient", "", "Therapiescout");
      }

      break;
    case 'fachkreis__form--serviceportal':

      if (!$data.success) {
        $('[data-form="' + $form + '"]').find('small.form-text').text($data.exception).slideDown();
      }


      if ($data.success) {

        if ($data.data.isHcpPortalUser === true) {

          $('[data-form="' + $form + '"]').find('small.form-text').text('Dies ist kein gültiger Fachkreis-Login.').slideDown();

        } else {

          redirect = (!isXstage ? '/portal/' : 'https://abbvie-care-stage.twt-dh.de/portal/');

          if ($data.data.password_expired === true) {
            activate_system_screen('pwd-expired');
            return false;
          }

          window.location.href = redirect;

        }

      }

      break;
    case 'fachkreis__form--aktivierungscode':

      if (!$data.success) {
        $('[data-form="' + $form + '"]').find('small.form-text').text($data.exception).slideDown();
      }


      if ($data.success) {
        window.location.href = (!isXstage ? '/portal/activation?key=' + encodeURI($request.activation_id) : 'https://abbvie-care-stage.twt-dh.de/portal/activation?key=' + encodeURI($request.activation_id));
      }

      break;
    case 'fachkreis__form--partnerapp':

      if (!$data.success) {
        $('[data-form="' + $form + '"]').find('small.form-text').text($data.exception).slideDown();
      }

      if ($data.success) {

        if ($data.data.isHcpPortalUser === true && $data.data.authToken) {

          redirect = (!isXstage ? '/portal/partner/' : 'https://abbvie-care-stage.twt-dh.de/portal/partner/') + '?authtoken=' + encodeURI($data.data.authToken);

          if ($data.data.password_expired === true) {
            activate_system_screen('pwd-expired');
            return false;
          }

          window.location.href = redirect;

        } else {

          $('[data-form="' + $form + '"]').find('small.form-text').text('Dies ist kein gültiger Partner-App-Login.').slideDown();

        }

      }

      break;
    case 'service__form--pwd-expired':

      if (!$data.success) {
        $('[data-form="' + $form + '"]').find('small.form-text').text($data.exception).slideDown();
      }

      if ($data.success) {

        //console.log('pwd changed successfully.. redirecting', $data, redirect);
        alert('Ihr Passwort wurde erfolgreich geändert.');
        window.location.href = redirect;

      }

      break;

    // Registration

    case 'registration_chargenr':
      if (!$data.success) {
        $('[data-form="' + $form + '"]').find('small.form-text').text($data.exception).slideDown();
      }

      if ($data.success) {
        registration.vars.therapy_type = $data.data.therapy_type;
        registration.init();
      }

      $('header, main, footer').addClass('nothidden');

      break;

    case 'registration_CreateUserRequest':

      //console.log($data);

      if ($data.success && $data.success === true) {
        var datetime = new Date();
        registration.vars.timeofcreation = datetime.getDate() + "/" + (datetime.getMonth() + 1) + "/" + datetime.getFullYear() + " " + datetime.getHours() + ":" + datetime.getMinutes() + ":" + datetime.getSeconds();
        var indication = registration.vars.indication ? registration.vars.indication : $('#registration [name="indication"]:checked').val();
        registrationFurtherQuestions(registration.vars.timeofcreation, registration.vars.therapy_type, indication, ["Keine Angabe"], 'keine Angabe');
        gtmTrackingForms("formSubmit", "Serviceprogramm Registration Form", registration.vars.steps.length+1, "Confirmation Page", registration.vars.step+1);
        var questionsHTML =
        '<h5>Wir würden uns freuen, wenn Sie die beiden folgenden Fragen kurz beantworten, damit noch mehr Patienten den einfachen Weg der Online-Anmeldung für AbbVie Care nutzen können.</h5> ' +
        '<form class="infobox">' +
          '<div class="col">' +
            '<strong>Wie haben Sie von der Möglichkeit der Online-Anmeldung zu AbbVie Care erfahren?</strong>' +
            '<p>Sie können mehrere Antworten anklicken.</p>' +
            '<div class="form-row d-xl-flex align-items-xl-center">' +
             '<div class="col-sm-12 col-md-12 d-xl-flex align-items-xl-center">' +
                '<div class="form-group answer1">' +
                 '<div class="form-check"><input class="form-check-input" type="checkbox" id="arzt" value="arzt" name="answer1"/><label class="form-check-label" for="arzt">Von meinem behandelnden Arzt</label></div>' +
                 '<div class="form-check"><input class="form-check-input" type="checkbox" id="arzthelfer" value="arzthelfer" name="answer1" /><label class="form-check-label" for="arzthelfer">Von der Arzthelferin aus meiner Arztpraxis</label></div>' +
                 '<div class="form-check"><input class="form-check-input" type="checkbox" id="ambulanz" value="ambulanz" name="answer1" /><label class="form-check-label" for="ambulanz">In der Krankenhausambulanz</label></div>' +
                 '<div class="form-check"><input class="form-check-input" type="checkbox" id="apotheke" value="apotheke" name="answer1" /><label class="form-check-label" for="apotheke">In der Apotheke</label></div>' +
                 '<div class="form-check"><input class="form-check-input" type="checkbox" id="anmeldemappe" value="anmeldemappe" name="answer1" /><label class="form-check-label" for="anmeldemappe">Aus der Anmeldemappe/ -broschüre zu AbbVie Care</label></div>' +
                 '<div class="form-check"><input class="form-check-input" type="checkbox" id="flyer" value="flyer" name="answer1" /><label class="form-check-label" for="flyer">Aus einem Flyer zur Online-Anmeldung</label></div>' +
                 '<div class="form-check"><input class="form-check-input" type="checkbox" id="internet" value="internet" name="answer1" /><label class="form-check-label" for="internet">Aus dem Internet auf www.abbvie-care.de</label></div>' +
                 '<div class="form-check"><input class="form-check-input" type="checkbox" id="freunde" value="freunde" name="answer1" /><label class="form-check-label" for="freunde">Von Freunden / Bekannten</label></div>' +
                 '<div class="form-check"><input class="form-check-input" type="checkbox" id="sonstiges" value="sonstiges" name="answer1" /><label class="form-check-label" for="sonstiges">Sonstiges</label></div>' +
                '</div>' +
              '</div>' +
            '</div>' +
          '</div>' +
          '<br>' +
          '<div class="col">' +
            '<strong>Wo haben Sie die Online-Anmeldung durchgeführt?</strong>' +
            '<div class="form-row d-xl-flex align-items-xl-center" style="margin-top: 5px;">' +
              '<div class="col-sm-12 col-md-12 d-xl-flex align-items-xl-center">' +
                '<div class="form-group d-flex flex-column answer2" style="width:100%;">' +
                  '<select class="form-control" id="registration_where" name="registration_where">' +
                    '<option value="keine Angabe">Wählen Sie eine Antwort</option>' +
                    '<option value="zuhause_allein">Allein oder mit Unterstützung zu Hause</option>' +
                    '<option value="praxis_mit_arzt">Mit dem Arzt oder der Arzthelferin in der Praxis</option>' +
                    '<option value="praxis_alleine">Allein in der Arztpraxis vom eigenen Smartphone</option>' +
                    '<option value="apotheke_mit_hilfe">Mit Hilfe in der Apotheke</option>' +
                    '<option value="sonstige_hilfe">Sonstige Unterstützung</option>' +
                  '</select >' +
                '</div>' +
              '</div>' +
            '</div>' +
          '</div>' +
          '<br>' +
          '<div class="col">' +
            '<button data-binding="further_questions" class="btn btn-primary " type="button">Abschicken</button>' +
          '</div>' +
        '</form>';

        $('.createuser_api_feedback h2').text('Vielen Dank für Ihre Angaben.');
        $('.createuser_api_feedback p').html('Wir haben Ihnen einen Bestätigungslink an die von Ihnen angegebene E&#8209;Mailadresse geschickt. Bitte klicken Sie auf diesen Link, um Ihre E-Mailadresse zu bestätigen. Der Link ist 14 Tage lang gültig.<br><br>Sollten Sie keine E-Mail mit einem Bestätigungslink erhalten, wenden Sie sich bitte an das AbbVie Care-Team unter 08000 48 64 72<br><br><br>' + questionsHTML);
        $('.veeva.divider, .veeva.copy--hideable, .veeva.copy--hidden').addClass('registration-finished');
        //$('.veeva.copy--hideable').html('DE-IMM-240007');
        //$('.veeva.copy--hidden').html('DE-IMM-240007');
        //$('.createuser_api_feedback .feedback_CTA').text('Abschicken').attr('data-binding','redirect_login');
        $('select[name^="registration_where"]').niceSelect();
        $('footer').css("z-index", "-1");
        $('.feedback_CTA').css("display", "none");
        $('.createuser_api_feedback').fadeIn();

      } else {

        if(typeof $data.exception === 'undefined') {

          $('.createuser_api_feedback h2').text('Leider ist ein Fehler aufgetreten');
          $('.createuser_api_feedback p').html('Wir arbeiten daran diesen schnellstmöglich zu beheben. Bitte versuchen Sie es später noch einmal, vielen Dank. Sollten Sie weiterhin Probleme bei der Registrierung haben, wenden Sie sich bitte an das AbbVie Care-Team unter 08000 48 64 72');

        } else {

          $('.createuser_api_feedback h2').text('Fehler: ' + $data.exception);
          $('.createuser_api_feedback p').html('Bitte überprüfen Sie Ihre Angaben. Sollten Sie weiterhin Probleme bei der Registrierung haben, wenden Sie sich bitte an das AbbVie Care-Team unter 08000 48 64 72');

        }

        $('.createuser_api_feedback .feedback_CTA').text('Zurück').attr('data-binding','back_to_check_feedback_error');
        $('.createuser_api_feedback').fadeIn();

      }

      break;

  }


  //Exception Handling

  if (!$data.success && $data.exception) {
    return false;
  } else if (!$data.success && !$('body').hasClass('registration')) {
    alert('Leider liegt momentan eine Störung vor. Wir arbeiten daran diese schnellstmöglich zu beheben. Bitte versuchen Sie es später noch einmal, vielen Dank.'); // complete ac Service Down / sb api <- no response
    return false;
  }


}


function deleteCookie(cname) {
  var d = new Date();
  d.setTime(d.getTime() - (1000*60*60*24));
  var expires = "expires=" + d.toGMTString();
  window.document.cookie = cname+"="+"; "+expires+"; path=/";
}


function sendAC2Request($request, $method, $form) {

  // delete cookies for requests
  deleteCookie('user_id');
  deleteCookie('sec_id');
  deleteCookie('dc_type');
  deleteCookie('dc_indication');
  deleteCookie('displayed_dc_id');
  deleteCookie('is_dc');


  $('body').addClass('preloader');

  if($request.password) {
    $('.service__form--pwd-expired [name="old_password"]').val($request.password);
    //console.log('submitted pwd', $('.service__form--pwd-expired [name="old_password"]').val());
  } else {
    //console.log('no pwd in request found');
  }

  var $url = (!isXstage ? '/portal/backend/content/themes/sage/core/api.php' : 'https://abbvie-care-stage.twt-dh.de/portal/backend/content/themes/sage/core/api.php');

  if (window.location.hostname.match(/local/)) {
    $url = 'http://local.abbvie-care-portal.de/content/themes/sage/core/api.php';
  }
  if (window.location.hostname.match(/schwarzundbold\./)) {
    //$url = 'http://abbvie-care.lvps87-230-17-74.dedicated.hosteurope.de/content/themes/sage/core/api.php';
    $url = '/portal/backend/content/themes/sage/core/api.php';
  }

  $.ajax({
    url: $url,
    type: "post",
    data: '{"method":"' + $method + '","request": ' + JSON.stringify($request) + '}',
    success: function (data) {
      callback(data, $method, $form, $request);
    },
    error: function (error) {
      //for testing
      //callback(JSON.parse('{"success":true,"data":{"codeType":"patient","isChargenumber":true,"medicationName":"Humira 75MG\/0.83ML PFS X2 DE SMP","therapy_type":"Skyrizi"}}'), $method, $form, $request);
      $('.preloader_container').fadeOut();

      console.log('error', error);

      if($('body').hasClass('registration')) {

        $('.createuser_api_feedback h2').text('Leider liegt momentan eine Störung vor.');
        $('.createuser_api_feedback p').html('Wir arbeiten daran diese schnellstmöglich zu beheben. Bitte versuchen Sie es später noch einmal, vielen Dank. Sollten Sie weiterhin Probleme bei der Registrierung haben, wenden Sie sich bitte an das AbbVie Care-Team unter 08000 48 64 72');              $('.createuser_api_feedback .feedback_CTA').text('Zurück').attr('data-binding','back_to_check_feedback_error');
        $('.createuser_api_feedback').fadeIn();

      } else {

        alert('Leider liegt momentan eine Störung vor. Wir arbeiten daran diese schnellstmöglich zu beheben. Bitte versuchen Sie es später noch einmal, vielen Dank.'); // sb api offline/401/500

      }

    }
  });

}

/* jshint ignore:start */


function getInternetExplorerVersion() {
  var rv = -1;
  if (navigator.appName == 'Microsoft Internet Explorer') {
    var ua = navigator.userAgent;
    var re = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
    if (re.exec(ua) != null)
      rv = parseFloat(RegExp.$1);
  } else if (navigator.appName == 'Netscape') {
    var ua = navigator.userAgent;
    var re = new RegExp("Trident/.*rv:([0-9]{1,}[\.0-9]{0,})");
    if (re.exec(ua) != null)
      rv = parseFloat(RegExp.$1);
  }
  return rv;
}

/* jshint ignore:end */


$('small.form-text').hide().removeClass('d-none');

function updateCookie(cname, cvalue) {
  var d = new Date();
  d.setTime(d.getTime() + (900*1000*60*60*24));
  var expires = d.toGMTString();
  window.document.cookie = cname + "=" + encodeURIComponent(cvalue) + "; expires=" + expires + "; path=/";
}

function preSelectTab(settings) {
  var tabToSet = "";
  switch (settings.bodyClass) {
    case 'patient':
      tabToSet = settings.selectedTabPatient;
      break;
    case 'fachkreis':
      tabToSet = settings.selectedTabFachkreis;
      break;
  }
  if (!tabToSet) {
    tabToSet = '#' + $('.' + settings.form).parents('.tab-pane').attr('id');
  }
  return tabToSet;

}

function disable_maintenance_login() {

  if(window.location.href.indexOf('dev_key=5945sgh9s872ajo5345') > -1) {
    return;
  }

  $('body').addClass('maintenance');

  $('[class*="form--serviceportal"],[data-form="registration_chargenr"], .portal_login, [class*="fachkreis__form--partnerapp-doccheck"]').each(function() {

    var tab_content;

    if(!$(this).parents('.tab-pane').length) {
      tab_content = $(this).parents('[id="registration"]');
    } else {
      tab_content = $(this).parents('.tab-pane');
    }

    tab_content.parent('.tab-content').prev('.nav-tabs').find('.nav-item:eq('+ tab_content.index() +')').addClass('has-maintenance');
    tab_content.addClass('closed').append('<div class="error-message"><h1 class="error-message__headline">Kurze Verschnaufpause</h1><p class="error-message__paragraph">Das Patienten-Portal wird aktuell überarbeitet und ist in Kürze wieder verfügbar. Vielen Dank für Ihr Verständnis.</p><p>Ihr AbbVie Care-Team</p>');

  });
}


(function ($) {

  // Check Portal for maintenance
  $.get("https://www.abbviecare.de", function(data) {
    //console.log(data);
  }).done(function() {
    // No maintenance Mode detected

    if(window.location.href.indexOf('sim_main') > -1 || window.maintenance) {
      disable_maintenance_login();
    }

  }).fail(function(data, textStatus, xhr) {

    if(data.status === 503) {
      disable_maintenance_login();
    }

    if(window.location.href.indexOf('sim_main') > -1 || window.maintenance) {
      disable_maintenance_login();
    }

  }).always(function() {


    // INIT


    //called on pageload
    if (getInternetExplorerVersion() > 1) {
      $('body').addClass('is-ie');
      $('.flex-grow-0').removeClass('flex-grow-0');
    }

    if (Cookies.acl) {

      settings = JSON.parse(atob(decodeURIComponent(Cookies.acl)));

    } else {
      //console.log('nothing set');
    }
    var activeTab = preSelectTab(settings);
    $('.nav-tabs a[href="' + activeTab + '"]').tab('show');
    $('.abv_select').niceSelect();

    $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
      switch (settings.bodyClass) {
        case 'patient':
          settings.selectedTabPatient = $(e.target).attr("href");
          break;
        case 'fachkreis':
          settings.selectedTabFachkreis = $(e.target).attr("href");
          break;
      }
      updateCookie("acl", btoa(JSON.stringify(settings)));
    });

    $('.patient__body .abv_select').on('change', function () {
      //console.log('.nav-tabs a[href="'+ this + '"]');
      $('.nav-tabs a[href="' + $(this).val() + '"]').tab('show');
    });

    $('.fachkreis__body .abv_select').on('change', function () {
      $('.nav-tabs a[href="' + $(this).val() + '"]').tab('show');

    });

    if ($('.closeOverlay').attr('href') !== '') {
      $('body').addClass('overlay');
    }

    if($('body').hasClass('registration')) {
      $('body').removeClass('preloader').addClass('patient');
    } else {
      $('body').removeClass('preloader').addClass(settings.bodyClass);
    }

    if($('body').hasClass('registration')) {





      // Populate Selects
      generateSelectionItems($('select[name="dateOfBirth_day"]'),'countFromTo', '<option disabled selected  value="">Tag</option>',1,31);
      generateSelectionItems($('select[name="dateOfBirth_month"]'),'getMonths', '<option  disabled selected value="">Monat</option>');
      generateSelectionItems($('select[name="dateOfBirth_year"]'),'yearsFromNow', '<option  disabled selected value="">Jahr</option>',1930,0);
      generateSelectionItems($('select[name="validTimeFrom"]'),'time');
      generateSelectionItems($('select[name="validTimeUntil"]'),'time_end_selected');

      // Init Nice Selects


      if(!window.location.href.match(/dev/)) {
        $('select[name^="dateOfBirth_"], select[name^="validTime"]').niceSelect();
      }


      registration = {
        '_this':this,
        'requestBody': {},
        'vars': {
          'authCode': null,
          'validated_page_ids': [],
          'therapy_type': null,
          'validationError': false,
          'indication': null,
          'indication_name': null,
          'step': 1,
          'therapy_type_step_templates': {
            'Humira': ['[data-step="1"]', '[data-step="2"]', '[data-step="3"]', '[data-step="4"]', '[data-step="5"]'],
            'Skyrizi': ['[data-step="1"]', '[data-step="2"]', '[data-step="3"]', '[data-step="4"]', '[data-step="5"]'],
            'Rinvoq': ['[data-step="1"]', '[data-step="2"]', '[data-step="3"]', '[data-step="4"]', '[data-step="5"]']
          },
          'steps': []
        },
        init: function() {

          if($('body').hasClass('maintenance')) {
            window.location.href="/login/";
            return false;
          }

          // Set Steps Selectors
          registration.vars.steps = registration.vars.therapy_type_step_templates[ registration.vars.therapy_type ];

          if(typeof registration.vars.steps === 'undefined') {
            alert('Dieser Therapie-Typ ist leider nicht gültig. Bitte wenden Sie sich an das AbbVie Care-Team unter 08000 48 64 72');
            window.location.href = '/login/registrierung/';
          }

          // Autoset Indication for Skyrizi & remove ability to change diagnosis later on this therapy_type
          // if(registration.vars.therapy_type === 'Skyrizi') {
          //   registration.vars.indication = 467505;
          //   registration.vars.indication_name = 'Psoriasis (Pso)';
          //   $('#check_row_diagnosis').addClass('nocheck');
          // }

          // Show only TherapyType Indications on Indication Choice Screen

          $('[data-therapy_type_visible]').each(function() {
            if($(this).attr('data-therapy_type_visible').indexOf(registration.vars.therapy_type.toLowerCase()) < 0) {
              $(this).hide();
            }
          });

          // Init Header Navigation

          $('.registration_progress').show();

          $('.registration_progress .col .col').slice(0,registration.vars.steps.length ).each(function(index) {

            $(this).show();
            if(index === registration.vars.steps.length - 1) {
              $(this).addClass('last');
            }

          });

          registration.buildRequestData();
          registration.changeNavigation();

          //set veeva for specific meds
          if (registration.vars.therapy_type) {
            switch (registration.vars.therapy_type.toLowerCase()) {
              case "humira":
                $('.copy.veeva').html("DE-IMM-220237");
              break;
              case "skyrizi":
                $('.copy.veeva').html("DE-IMM-240015");
              break;
              case "rinvoq":
                $('.copy.veeva').html("DE-IMM-230092");
              break;
              default:
                break;
            }
          }
          
          $('body').attr('data-registration-step', registration.vars.step );
          $('body').attr('data-therapy_type', registration.vars.therapy_type);

          $('div[data-step]').hide();
          $(registration.vars.steps[ registration.vars.step - 1 ]).show();
          $('.navigation').show();

          // Binding
          $(document).on('click','.navigation .btn-primary', this.next_page );
          $(document).on('click','.navigation .btn-outline-primary', this.previous_page );

          $(document).on('click','.registration_progress .confirmed_step > *', function() {
            registration.change_page($(this).parent('.col').index() + 1);
            return false;
          });

          $(document).on('click','.registration_change_details', function(e) {
            e.preventDefault();
            registration.change_page($(this).attr('data-backtostep'));
            return false;
          });

          $(document).on('click','[data-binding="back_to_check_feedback_error"]', function() {
            //$('.registration__header').slideDown();
            $('.createuser_api_feedback').hide();
            $(registration.vars.steps[ registration.vars.step - 1 ] + ', .navigation').fadeIn();
            $('header').removeClass('small_height');
          });


          $(document).on('click','[data-binding="redirect_login"]', function() {
            window.location.href = '/login/';
          });



          $(document).on('click', '[data-binding="further_questions"]', function () {
            var indication = registration.vars.indication ? registration.vars.indication : $('#registration [name="indication"]:checked').val();
            var answer1 = [];
            $.each($("input[name='answer1']:checked"), function(){
              answer1.push($(this).val());
            });
            if (answer1.length === 0) {
              answer1.push("keine Angabe");
             }
            registrationFurtherQuestions(registration.vars.timeofcreation, registration.vars.therapy_type, indication, answer1, $('#registration_where').val());
            setTimeout(function(){ $('.createuser_api_feedback p').html('Vielen Dank für Ihre Angaben. Wir haben Ihnen einen Bestätigungslink an die von Ihnen angegebene E&#8209;Mailadresse geschickt. Bitte klicken Sie auf diesen Link, um Ihre E-Mailadresse zu bestätigen. Der Link ist 14 Tage lang gültig.<br><br>Sollten Sie keine E-Mail mit einem Bestätigungslink erhalten, wenden Sie sich bitte an das AbbVie Care-Team unter 08000 48 64 72<br><br><br>' + "<div class='infobox'>Vielen Dank für Ihre Mitwirkung bei dieser Befragung.</br>Ihr AbbVie Care-Team.</div>");
            }, 200);
          });

          $( "#dateOfBirth_day, #dateOfBirth_month, #dateOfBirth_year" ).change(function() {
            if ($("#dateOfBirth_day").val() &&  $("#dateOfBirth_month").val() && $("#dateOfBirth_year").val()) {
              var date_set = new Date($("#dateOfBirth_month").val() + " " + $("#dateOfBirth_day").val() + " " + $("#dateOfBirth_year").val());
              var date_now = Date.now();
              var diff =(date_now - date_set) / 1000;
              diff /= (60 * 60 * 24);
              //-1 day fix
              if (Math.abs((diff -1)/365.25) < 18) {
                $("#underage_confirm").attr("required", true);
                $(".underage_confirm_row").css("display", "flex");
              }
              else {
                $("#underage_confirm").removeAttr("required");
                $(".underage_confirm_row").fadeOut();
              }



            }

          });

          // UsePortal Switch
          $(document).on('change','#usePortal', function() {

            if($(this).is(':checked')) {
              $('.user_portal_pwd_inputs input[type="password"]').removeAttr('disabled');
              $('.user_portal_pwd_inputs').slideDown('fast');
            } else {
              $('.user_portal_pwd_inputs').slideUp('fast');
              $('.user_portal_pwd_inputs input[type="password"]').attr('disabled','');
            }

          });

          gtmTrackingForms("formView", "Serviceprogramm Registration Form", registration.vars.steps.length+1, "Kontaktdaten", registration.vars.step);

        },
        validate: function() {

          var validationError = false;

          // Hide Error Messages
          $(registration.vars.steps[ registration.vars.step - 1 ] + ' small').remove();

          // Cycle through visible Inputs/Selects
          $(registration.vars.steps[ registration.vars.step - 1 ] + ' input[required]:visible, '+ registration.vars.steps[ registration.vars.step - 1 ] + ' select[required]').each(function() {


            var error = $('<small class="form-text text-muted" style="display: none;"></small>');

            switch(true) {


              // Check if empty

              case (($(this).val() === '' || $(this).find(':selected').val() === '') && $(this).attr('name') !== 'mobilSuffix'):
                error.text('Pflichtangabe');

                if($(this).parent('.form-group').length) {
                  $(this).parent('.form-group').after(error);
                } else {
                  $(this).after(error);
                }

                error.show();
                validationError = true;
                break;


              // check checkboxes are empty

              case ($(this).attr('type') === 'checkbox' && !$(this).is(':checked')):
                error.text('Pflichtangabe');
                $(this).parent('.form-check').after(error);
                if (!$(this).hasClass("underage_confirm_checkbox")) {
                  error.css('display', 'inline-block');
                }
                error.show();
                validationError = true;
                break;


              /*case ($(this).attr('type') === 'radio' && !$(this).is(':checked')):

                  error.text('Pflichtangabe');
                  $(this).parent('.form-check').after(error);
                  error.css('display', 'inline-block').show();
                  validationError = true;

                  break;
              */

                //phone number validation 49 + 6-13 digits, only numbers
              case ($(this).attr('name') === 'phoneSuffix'):
                var fullNumber = $('#registration [name="phonePrefix"]').val() + $('#registration [name="phoneSuffix"]').val();

                var re2 = /^((0{0,}|\+{0,})(49)|(0{1,}|\+{1,})(49)?)/;
                //remove leading 0, 49 and + at start
                var cleanNumber = fullNumber.replace(re2, "");
                //check if only numbers and between 6 and 13
                re2 = /^[0-9]{6,13}$/;

              if(!cleanNumber.match(re2)) {
                error.text('Rufnummer und Vorwahl müssen zusammen zwischen 6 und 13 Zeichen lang sein und dürfen nur aus Zahlen bestehen.');
                $('#registration [name="phoneSuffix"]').after(error);
                error.show();
                validationError = true;
              }

              break;

                //mobile number validation 49 + 9-13 digits
              case ($(this).attr('name') === 'mobilSuffix'):
                var fullNumber2 = $('#registration [name="mobilSuffix"]').val();

                if (fullNumber2 === "") {
                  break;
                }
                var re3 = /^((0{0,}|\+{0,})(49)|(0{1,}|\+{1,})(49)?)/;
                //remove leading 0, 49 and + at start
                var cleanNumber2 = fullNumber2.replace(re3, "");
                re3 = /^[0-9]{9,13}$/;

              if(!cleanNumber2.match(re3)) {
                error.text('Die Rufnummer muss zwischen 9 und 13 Zeichen lang sein und darf nur aus Zahlen bestehen.');
                $('#registration [name="mobilSuffix"]').after(error);
                error.show();
                validationError = true;
              }

              break;



              // Check Email Fields

              case ($(this).attr('type') === 'email'):
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if(!re.test(String($(this).val()).toLowerCase())) {
                  error.text('Bitte geben Sie eine gültige E-Mail-Adresse an');
                  $(this).after(error);
                  error.show();
                  validationError = true;
                }
                break;

                // Check for german zip code of doctor

              case ($(this).attr('name') === 'zip'):
                var re4 = /^\d{5}$/;
                if(!(re4.test(String($(this).val())) && parseInt($(this).val()) > 1066 && parseInt($(this).val()) < 99999)) {
                  error.text('Ihr behandelnder Arzt muss in Deutschland ansässig sein.');
                  $(this).after(error);
                  error.show();
                  validationError = true;
                }
                break;




              // Check passwords

              case ($(this).attr('type') === 'password'):

                // check for alpha numeric

                var letter = /[a-zA-Z]/;
                var number = /[0-9]/;
                var sonderzeichen = /\W+/;
                var valid = number.test($(this).val()) && (letter.test($(this).val()) || sonderzeichen.test($(this).val()));

                if(!valid) {
                  error.text('Passwort muss alphanumerisch sein');
                  validationError = true;
                }

                // check for length
                if($(this).val().length < 8) {
                  error.text('Passwort ist zu kurz');
                  validationError = true;
                }

                // Check PWD confirm

                if($(this).attr('name') === 'password_confirm') {
                  if($(this).val() !== $(this).parents('.form-group').find('input[type="password"]:eq(0)').val()) {
                    error.text('Passwort stimmt nicht überein');
                    validationError = true;

                  }
                }

                // render error

                if(validationError === true) {
                  $(this).after(error);
                  error.show();
                }

                break;

            }

          });


          // Special Validation Cases

          // Indication Choice

          var indication = $(registration.vars.steps[ registration.vars.step - 1 ] + ' input[name="indication"]');
          var indicationIsChecked = $(registration.vars.steps[ registration.vars.step - 1 ] + ' input[name="indication"]:checked');

          if(indication.length && !indicationIsChecked.length) {
            alert('Bitte wählen Sie eine Erkrankung aus');
            validationError = true;
          }

          // Show / Hide SMS Optin / show hide sms option control panel
          if( $('#registration [name="mobilPrefix"]').val() === '' || $('#registration [name="mobilSuffix"]').val() === '' ) {
            $('.form-check.sms_optin').hide();
            $('.mobile_no').hide();
          } else {
            $('.form-check.sms_optin').show();
            $('.mobile_no').show();
          }

          // show hide pwd portal on control panel

          if($('#portal_pwd').is(':hidden')) {
            $('.uses_portal_cp').hide();
          }

          return !validationError;
          //return true;

        },
        changeNavigation: function() {

          // Change Submit Text
          if(registration.vars.step === registration.vars.steps.length) {
            $('.navigation .btn-primary').html('<span class="show_mobile">Registrieren</span><span class="hide_mobile">Registrierung abschließen</span>');//.addClass()
          } else if(registration.vars.step === registration.vars.steps.length - 1) {
            $('.navigation .btn-primary').text('Eingaben überprüfen');
          } else {
            $('.navigation .btn-primary').html('Weiter<span class="long_desc"> zum nächsten Schritt</span>');
          }

          // Header Texts / Header Navigation / Wizard
          $('.registration__header .text p').text('Schritt ' + registration.vars.step + ': ' + $(registration.vars.steps[ registration.vars.step - 1 ]).attr('data-step-title'));
          $('.registration__header .col .col').removeClass('current_step');
          $('.registration__header .col .col:eq('+ (registration.vars.step -1) +')').addClass('current_step');

          // Toogle Back Button Visiblity
          if(registration.vars.step === 1) {
            $('.navigation .btn-outline-primary').hide();
          } else {
            $('.navigation .btn-outline-primary').show();
          }

          $('html,body').animate({ scrollTop: 0 }, 'fast');

        },
        change_page: function(page) {

          //console.log('current page',registration.vars.step);

          // Switch to page
          $(registration.vars.steps[ registration.vars.step - 1 ]).hide();
          registration.vars.step = parseInt(page);


          //console.log('switching to page >',registration.vars.step );
          $(registration.vars.steps[ registration.vars.step - 1 ]).show();
          // Check Navigation State
          registration.changeNavigation();
          registration.buildRequestData();

        },
        next_page: function() {



          if (registration.vars.step !== registration.vars.steps.length) {

            if (registration.validate()) {

              gtmTrackingForms("formStep", "Serviceprogramm Registration Form", registration.vars.steps.length+1, $(registration.vars.steps[registration.vars.step]).attr('data-step-title'), registration.vars.step+1);

              // Mark Step as validated
              

              $('.registration__header .col .col:eq('+ (registration.vars.step -1) +')').addClass('confirmed_step');
              if(registration.vars.validated_page_ids.indexOf(registration.vars.step) === -1) {
                registration.vars.validated_page_ids.push(registration.vars.step);
              }
              //console.log('no errors found.', 'index of '+registration.vars.step +' in array -> ', registration.vars.validated_page_ids.indexOf(registration.vars.step),registration.vars.validated_page_ids);

              // goto page
              registration.change_page(registration.vars.step + 1);

            } else {

              registration.vars.validated_page_ids.splice(registration.vars.validated_page_ids.indexOf(registration.vars.step),1);
              $('.registration__header .col .col:eq('+ (registration.vars.step -1) +')').removeClass('confirmed_step');
              //console.log('errors found!', 'index of '+registration.vars.step +' in array -> ', registration.vars.validated_page_ids.indexOf(registration.vars.step),registration.vars.validated_page_ids);

            }

          } else {

            // If last step -> fire event
            if (registration.vars.step === registration.vars.steps.length) {

              //$('.registration__header').fadeOut();
              $('div[data-step], .navigation').fadeOut();
              $('html,body').scrollTop(0);
              $('header').addClass('small_height');
              registration.sendRequest();

            }

          }

        },
        previous_page: function() {

          if(registration.vars.step !== 1 ) {

            registration.change_page(registration.vars.step -1 );

          }

        },
        buildRequestData: function() {

          registration.requestBody = {

            "authCode": registration.vars.authCode,
            "codeType": "patient",
            "isChargenumber": false,
            "contactDetails": {
              "firstName": $('#registration [name="firstName"]').val(),
              "lastName": $('#registration [name="lastName"]').val(),
              "street": $('#registration [name="street"]').val(),
              "streetNo": $('#registration [name="streetNo"]').val(),
              "zip": $('#registration #contact_zip').val(),
              "city": $('#registration #contact_city').val(),
              "phonePrefix": $('#registration [name="phonePrefix"]').val(),
              "phoneSuffix": $('#registration [name="phoneSuffix"]').val(),
              "email": $('#registration [name="email"]').val(),
              "mobilPrefix": $('#registration [name="mobilPrefix"]').val(),
              "mobilSuffix": $('#registration [name="mobilSuffix"]').val(),
              "gender": $('#registration [name="gender"]:checked').val(),
              "dateOfBirth": $('#registration [name="dateOfBirth_year"]').find(':selected').val() + '-' + $('#registration [name="dateOfBirth_month"]').find(':selected').val() + '-' + $('#registration [name="dateOfBirth_day"]').find(':selected').val(),
              "therapy_type": registration.vars.therapy_type
            },
            "portal": {
              "usePortal": ($('#usePortal:checked').length ? true : false),
            },
            "newsletter": {
              "receiveNewsletter": false
            },
            "chargeNumberService": {
              "addInitChargeNumber": true
            },
            "diagnosis": {
              "indicationName": (registration.vars.indication ? registration.vars.indication : $('#registration [name="indication"]:checked').val()),
              "doctorInfo": {
                "address": {
                  "streetName": $('#registration [name="streetName"]').val(),
                  "streetNumber": $('#registration [name="streetNumber"]').val(),
                  "zip": $('#registration #doctor_zip').val(),
                  "city": $('#registration #doctor_city').val()
                },
                "name": $('#registration [name="name"]').val()
              }
            },
            "misc": {
              "sendStarterSet": ($('#registration [name="sendStarterSet"]:checked').val() === 'true' ? true : false)
            },
            "reachability": {
              "validDays": {
                "monday": ($('#registration #monday:checked').length ? true : false),
                "tuesday": ($('#registration #tuesday:checked').length ? true : false),
                "wednesday": ($('#registration #wednesday:checked').length ? true : false),
                "thursday": ($('#registration #thursday:checked').length ? true : false),
                "friday": ($('#registration #friday:checked').length ? true : false)
              },
              "validTimeFrom": $('#registration [name="validTimeFrom"]').find(':selected').val(),
              "validTimeUntil": $('#registration [name="validTimeUntil"]').find(':selected').val(),
              "allowMailboxMobile": ( $('#registration #allowMailboxMobile:checked').length ? true : false),
              "allowMailboxLandline": ($('#registration #allowMailboxMobile:checked').length ? true : false),
              "allowEmail": ($('#registration #allowEmail:checked').length ? true : false),
              "allowSms": ($('#registration #allowSms:checked').length ? true : false)
            }
          };

          // Insert conditional fields
          if($('#usePortal:checked').length) {
            registration.requestBody.portal.password = $('#registration [name="password"]').val();
          }


          // Populate Control Screen
          $('.check_firstName').text(registration.requestBody.contactDetails.firstName);
          $('.check_lastName').text(registration.requestBody.contactDetails.lastName);
          $('.check_street-streetNo').text(registration.requestBody.contactDetails.street + ' '+ registration.requestBody.contactDetails.streetNo);
          $('.check_zip-city').text(registration.requestBody.contactDetails.zip + ' ' + registration.requestBody.contactDetails.city);
          $('.check_telephone').text(registration.requestBody.contactDetails.phonePrefix + ' / ' + registration.requestBody.contactDetails.phoneSuffix);
          $('.check_mobile').text(registration.requestBody.contactDetails.mobilPrefix + ' / ' + registration.requestBody.contactDetails.mobilSuffix);
          $('.check_dateOfBirth').text($('#registration [name="dateOfBirth_day"]').find(':selected').val() + '.' + $('#registration [name="dateOfBirth_month"]').find(':selected').val() + '.' + $('#registration [name="dateOfBirth_year"]').find(':selected').val() );
          $('.check_email').text(registration.requestBody.contactDetails.email);
          $('.check_indication').html('<span class="yes_icon"></span>' + (registration.vars.indication ? registration.vars.indication_name : $('#registration [name="indication"]:checked + label').text()));
          $('.check_usePortal').html($('#usePortal:checked').length ? '<span class="yes_icon"></span>Ja, ich möchte den Online-Servicebereich nutzen (kostenlos)' : '<span class="no_icon"></span>Nein, ich möchte den Online-Servicebereich nicht nutzen');


          var reachability_day_strings = '';

          if($('#registration #monday:checked').length) { reachability_day_strings += 'Montag, '; }
          if($('#registration #tuesday:checked').length) { reachability_day_strings += 'Dienstag, '; }
          if($('#registration #wednesday:checked').length) { reachability_day_strings += 'Mittwoch, '; }
          if($('#registration #thursday:checked').length) { reachability_day_strings += 'Donnerstag, '; }
          if($('#registration #friday:checked').length) { reachability_day_strings += 'Freitag, '; }

          $('.check_reachability').text(reachability_day_strings + 'von ' + $('#registration [name="validTimeFrom"]').find(':selected').val() + ' bis ' + $('#registration [name="validTimeUntil"]').find(':selected').val());

          $('.check_allowed_contact_methods').html(($('#registration #allowMailboxMobile:checked').length ? '<span class="yes_icon"></span>Ja, das AbbVie Care-Serviceteam darf auf dem Anrufbeantworter des o.g. Telefons eine Nachricht mit der Bitte um Rückruf hinterlassen' : '<span class="no_icon"></span>Nein, das AbbVie Care-Serviceteam darf auf dem Anrufbeantworter des o.g. Telefons keine Nachricht mit der Bitte um Rückruf hinterlassen'));
          // TODO was ist mit email und sms im status?

          $('.check_doctorName').text(registration.requestBody.diagnosis.doctorInfo.name);
          $('.check_doctorAddress').html(registration.requestBody.diagnosis.doctorInfo.address.streetName + ' ' + registration.requestBody.diagnosis.doctorInfo.address.streetNumber + '<br>' + registration.requestBody.diagnosis.doctorInfo.address.zip + ' ' + registration.requestBody.diagnosis.doctorInfo.address.city);
          $('.check_starterSet').html(($('#registration [name="sendStarterSet"]:checked').val() === 'true' ? '<span class="yes_icon"></span>Ja, ich möchte das Starterset mit vielen Informationen zur Behandlung und praktischen Tipps für einen guten Therapiestart erhalten' : '<span class="no_icon"></span>Nein, ich möchte das Starterset mit vielen Informationen zur Behandlung und praktischen Tipps für einen guten Therapiestart nicht erhalten'));

          //console.log(registration.requestBody);

          //remove starterset for riesenzell
              if (registration.requestBody.diagnosis.indicationName && registration.requestBody.diagnosis.indicationName === "DE-IN-163") {
                $('#registration #sendStarterSet_false').prop("checked", true);
                $('#registration .starterset').css("display", "none");
                $('#registration .starterset-summary').css("display", "none");
                
              }

        },
        sendRequest: function() {

          sendAC2Request(registration.requestBody, 'registrationCreateUserRequest', 'registration_CreateUserRequest');
          //console.log(registration.requestBody);


        }
      };



      // Registrierung ohne AuthCode überprüfung bzw. via GET Param
      if(gup('cn') && !$('body').hasClass('maintenance')) {
        registration.vars.authCode = gup('cn');
        $('input[name="authCode"]').val(registration.vars.authCode);
        sendAC2Request({"authCode": registration.vars.authCode }, 'registrationValidateAuthCodeRequest', 'registration_chargenr');
      }

    }

    // Show Page (only without cn param. with cn param wait for authCode check to validate firsts
    if(!gup('cn') || $('body').hasClass('maintenance')) {
      $('header, main, footer').addClass('nothidden');
    }



//BINDING

    $(document).on('change', '#login_select', function () {

      switch ($(this).val()) {

        case 'login_user':
          $('.section-item > .login').hide();
          $('.section-item--login').show();
          break;

        case 'login_activation':
          window.location.href = '/portal/activation';
          break;

        case 'login_parkinson':
          $('.section-item > .login').hide();
          $('.section-item--parkinson').show();
          break;

        case 'login_dc':
          $('.section-item > .login').hide();

          if (dcLogin) {
            $('.section-item--doccheck > div').append(dcLogin);
            dcLogin = false;
          }

          $('.section-item--doccheck').show();
          break;

      }

    });

    $(document).on('click', '[data-binding="cancel-system-screen"]', function () {
      deactivate_system_screen();
    });

    $(document).on('click', '[data-form] button[type="submit"]', function (event) {


      var form = $(this).parents('form').attr('data-form');
      var $request;

      //console.log(form);

      if (!form.match(/doccheck/)) {

        event.preventDefault();

      } else {

        //console.log('running doccheck validation');
        //Doccheck validation

        if ($('[data-form="' + form + '"]').find('[name="username"]').val() === '' || $('[data-form="' + form + '"]').find('[name="password"]').val() === '') {

          $('[data-form="' + form + '"]').find('small.form-text').text('Bitte füllen Sie alle Felder aus.').slideDown();
          return false;

        }

      }


      $('[data-form] small.form-error').slideUp();

      switch (form) {

        case 'patient__form--serviceportal':

          $request = {
            'username': $('[data-form="' + form + '"]').find('[name="benutzername"]').val(),
            'password': $('[data-form="' + form + '"]').find('[name="passwort"]').val(),
          };

          if ($request.username === '' || $request.password === '') {

            $('[data-form="' + form + '"]').find('small.form-text').text('Bitte füllen Sie alle Felder aus.').slideDown();
            return false;

          }

          sendAC2Request($request, 'loginRequest', form);

          break;


        case 'patient__form--aktivierung':

          $request = {
            'activation_id': $('[data-form="' + form + '"]').find('[name="aktivierungscode"]').val(),
          };

          if ($request.activation_id === '') {

            $('[data-form="' + form + '"]').find('small.form-text').text('Bitte geben Sie einen Aktivierungscode ein.').slideDown();
            return false;

          }

          sendAC2Request($request, 'verificationRequest', form);

          break;


        case 'patient__form--serviceportal-pumpennummer':

          var pump_id = $('[data-form="' + form + '"]').find('[name="pumpennummer"]').val();

          if (!pump_id.replace(/\s/g, '').length || pump_id === '') {

            $('[data-form="' + form + '"]').find('small.form-text').text('Bitte geben Sie Ihre Pumpennummer ein.').slideDown();
            return false;

          }

          $request = {
            'pump_id': pump_id
          };
          sendAC2Request($request, 'parkinsonLoginRequest', form);

          break;


        case 'patient__form--therapiescout':

          var authCode = $('[data-form="' + form + '"]').find('[name="chargennummer"]').val();

          if (!authCode.replace(/\s/g, '').length || authCode === '') {

            $('[data-form="' + form + '"]').find('small.form-text').text('Bitte geben Sie eine gültige Chargennummer ein.').slideDown();
            return false;

          }

          $request = {
            'authCode': authCode,
            'validator': 'therapiescout'
          };

          sendAC2Request($request, 'registrationValidateAuthCodeRequest', form);

          break;


        case 'fachkreis__form--serviceportal':

          $request = {
            'username': $('[data-form="' + form + '"]').find('[name="benutzername"]').val(),
            'password': $('[data-form="' + form + '"]').find('[name="passwort"]').val(),
          };

          if ($request.username === '' || $request.password === '') {

            $('[data-form="' + form + '"]').find('small.form-text').text('Bitte füllen Sie alle Felder aus.').slideDown();
            return false;

          }

          sendAC2Request($request, 'loginRequest', form);

          break;


        case 'fachkreis__form--aktivierungscode':

          $request = {
            'activation_id': $('[data-form="' + form + '"]').find('[name="aktivierungscode"]').val(),
          };

          if ($request.activation_id === '') {

            $('[data-form="' + form + '"]').find('small.form-text').text('Bitte geben Sie einen Aktivierungscode ein.').slideDown();
            return false;

          }

          sendAC2Request($request, 'verificationRequest', form);

          break;


        case 'fachkreis__form--partnerapp':

          $request = {
            'username': $('[data-form="' + form + '"]').find('[name="benutzername"]').val(),
            'password': $('[data-form="' + form + '"]').find('[name="passwort"]').val(),
          };

          if ($request.username === '' || $request.password === '') {

            $('[data-form="' + form + '"]').find('small.form-text').text('Bitte füllen Sie alle Felder aus.').slideDown();
            return false;

          }

          sendAC2Request($request, 'loginRequest', form);

          break;


        case 'service__form--pwd-expired':

          if(!sec_id || !user_id) {
            deactivate_system_screen();
            //console.log('sec_id or user_id not set. canceling');
          }

          $request = {
            "sec_id": sec_id,
            "user_id": user_id,
            "old_password": $('[data-form="' + form + '"]').find('[name="old_password"]').val(),
            "new_password": $('[data-form="' + form + '"]').find('[name="new_password"]').val(),
            "new_password_confirm": $('[data-form="' + form + '"]').find('[name="new_password_check"]').val()
          };


          if ($request.old_password === '') {
            $('[data-form="' + form + '"]').find('[name="old_password"]').parent('.form-group').removeClass('d-none');
            return false;
            //deactivate_system_screen();
          }


          if ($request.new_password === '') {
            $('[data-form="' + form + '"]').find('small.form-text').text('Bitte füllen Sie alle Felder aus.').slideDown();
            return false;
          }

          // PWD Validierung // TODO in funktion extrahieren


          if ($request.new_password.length < 8 || !$request.new_password.match(/(?=.*[0-9])/)) {

            $('[data-form="' + form + '"]').find('small.form-text').text('Das Passwort muss mindestens 8 Zeichen lang sein und mindestens eine Ziffer beinhalten.').slideDown();
            return false;
          }


          if ($request.new_password.match(/^[0-9]*$/)) {

            $('[data-form="' + form + '"]').find('small.form-text').text('Das Passwort darf nicht ausschließlich numerisch sein.').slideDown();
            return false;

          }

          if ($request.new_password !== $request.new_password_confirm) {

            $('[data-form="' + form + '"]').find('small.form-text').text('Die Passwörter stimmen nicht überein.').slideDown();
            return false;

          }


          //console.log('send request ', $request, 'changePasswordRequest', form);
          //return false;

          sendAC2Request($request, 'changePasswordRequest', form);


          break;



        // Registration

        case 'registration_chargenr':

          $request = {
            'authCode': $('[data-form="' + form + '"]').find('[name="authCode"]').val(),
          };

          if ($request.authCode === '') {

            $('[data-form="' + form + '"]').find('small.form-text').text('Bitte geben Sie eine Chargennummer ein.').slideDown();
            return false;

          }

          registration.vars.authCode = $request.authCode;
          sendAC2Request($request, 'registrationValidateAuthCodeRequest', form);

          break;





        default:

        //console.log('Form not registered or DocCheck');


      }


    });



  });

  $('.button_chronische').on('click', function(e) {
    
    // Check if it's a mobile device (basic width check)
    if (window.innerWidth <= 768) {
      e.preventDefault();
      // Add .show to all elements that currently have .hidden
      $('.hidden').addClass('show');

      // Add .hidden to all .to_hide elements
      $('.to_hide').addClass('hidden');
  
      
    }
  });
  


})(jQuery);
